<script setup lang="ts">
import Mfa from '@/pages/(home)/account/content/mfa.vue';
import BootstrapCard from '@/components/bootstrap/BootstrapCard.vue';

definePage({ name: 'AccountMfa', meta: { title: 'mfa.title' } });
</script>

<template>
  <h5>{{ $t('mfa.title') }}</h5>
  <Suspense>
    <Mfa />

    <template #fallback>
      <div>
        <BootstrapCard :shimmer="true" :shimmer-height="150" :header-text="$t('mfa.title')" class="mb-2" />
        <BootstrapCard :shimmer="true" :shimmer-height="150" :header-text="$t('mfa.authenticatorApp')" />
      </div>
    </template>
  </Suspense>
</template>

<style scoped>

</style>